function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnchecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 99.61 99.61"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 49.8,
  cy: 49.8,
  r: 48.28,
  transform: "rotate(-80.78 49.804 49.798)",
  style: {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: "3.05px"
  },
  "data-name": "Layer 2"
}));
export default SvgUnchecked;